document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('change', function (event) {
    if (event.target.matches('.sumit-on-select')) {
      addToCart(event.target);
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.matches('.swatch-input__product-card')) {
      updateSizeOptions(event.target);
    }
  });
});

async function updateSizeOptions(input) {
  const productCard = input.closest('.product-card-wrapper');
  const productLink = productCard.querySelector('a.full-unstyled-link');

  if (!productLink) {
    console.error('Product link not found.');
    return;
  }

  const productUrl = productLink.getAttribute('href');

  let handle;

  if (productUrl.includes('/products/')) {
    if (input.dataset.productVariant) {
      handle = input.dataset.productVariant;
    } else {
      handle = productUrl.split('/products/')[1].split('?')[0];
    }
  } else {
    handle = productUrl.split('?')[0];
  }

  if (!handle) {
    console.error('Product handle not found in URL.');
    return;
  }

  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) {
      throw new Error('Failed to fetch product data.');
    }

    const productData = await res.json();
    const selectedColor = input.value;
    const sizeInputs = productCard.querySelectorAll('.card__variations.card__variations-sizes input[type="radio"]');

    sizeInputs.forEach((sizeInput) => {
      const size = sizeInput.value;
      const variant = productData.variants.find((v) => v.options.includes(selectedColor) && v.options.includes(size));

      if (!variant || !variant.available) {
        sizeInput.classList.add('disabled');
        sizeInput.disabled = true;
      } else {
        sizeInput.classList.remove('disabled');
        sizeInput.disabled = false;
      }
    });

    const colorVariant = productData.variants.find((v) => v.options.includes(selectedColor) && v.available);
    const colorVariantId = colorVariant ? `?variant=${colorVariant.id}` : '';
    productLink.href = `/products/${handle}${colorVariantId}`;
  } catch (error) {
    console.error('Error loading product data:', error);
  }
}

async function addToCart(input) {
  const cart = document.querySelector('cart-drawer');
  if (!cart) {
    console.error('cart-drawer not found on the page.');
    return;
  }

  const size = input.value;
  let color = '';

  const colorInputsChecked = document.querySelectorAll('.swatch-input__input:checked');
  colorInputsChecked.forEach((colorInput) => {
    if (colorInput.form === input.form) {
      color = colorInput.value;
    }
  });

  if (!color) {
    if (input.dataset.externalVariantColor) {
      color = input.dataset.externalVariantColor;
    } else {
      const form = input.getAttribute('form');
      const colorInput = document.querySelector(`[form="${form}"]`);
      color = colorInput.value;
    }
  }

  if (!color || !size) {
    console.error('Color or Size not selected correctly.');
    return;
  }

  const product = input?.form?.querySelector(`#${CSS.escape(color + size)}`);
  if (!product) {
    console.error(`Product not found for combination: ${color} + ${size}`);
    return;
  }

  const idInput = input.form.querySelector('[name="id"]');
  if (!idInput) {
    console.error('Input [name="id"] not found in the form.');
    return;
  }
  idInput.value = product.dataset.variantId;

  const formData = new FormData(input.form);

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Failed to add item to cart.');
    }

    const responseData = await response.json();

    cart.classList.remove('is-empty');
    if (typeof cart.renderContents === 'function') {
      cart.renderContents(responseData);
    } else {
      console.warn('renderContents function not found on cart-drawer.');
    }
  } catch (error) {
    console.error('Error adding to cart:', error);
  }
}
